module.exports = __webpack_public_path__ + "static/ziggy_before-4f8e0d00351f2c12a7df4af7ca2b69d4.png";